"use client";

import { Lock, Clock, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const AccessBlockOverlay = ({ visible, reason, showRenewButton, onRenewNow, supportPhone }) => {
  if (!visible) return null;

  const isGraceExpired = reason === "GRACE_EXPIRED";
  const title = isGraceExpired ? "Subscription Renewal Needed" : "Account Deactivated";
  const message = isGraceExpired
    ? "Your subscription and grace period have expired. Renew now or contact us to restore access."
    : showRenewButton
      ? "Your account has been deactivated. Renew your subscription or contact us to restore access."
      : "Your account has been deactivated. Please contact your admin.";

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center rounded-2xl border border-gray-100 bg-white px-6 py-16 text-center shadow-sm">
      <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-amber-100 mb-5">
        {isGraceExpired ? (
          <Clock className="h-9 w-9 text-amber-700" />
        ) : (
          <Lock className="h-9 w-9 text-amber-700" />
        )}
      </div>
      <h2 className="text-xl font-bold text-gray-900 mb-2">{title}</h2>
      <p className="max-w-sm text-sm text-gray-500 leading-relaxed mb-7">{message}</p>

      {showRenewButton ? (
        <div className="flex w-full max-w-xs flex-col sm:flex-row gap-3">
          {supportPhone && (
            <Button
              type="button"
              variant="outline"
              className="flex-1"
              onClick={() => window.open(`tel:${supportPhone}`, "_self")}
            >
              <Phone className="h-4 w-4" />
              Contact Us
            </Button>
          )}
          <Button type="button" className="flex-1" onClick={onRenewNow}>
            Renew Now
          </Button>
        </div>
      ) : (
        supportPhone && (
          <Button
            type="button"
            className="w-full max-w-xs"
            onClick={() => window.open(`tel:${supportPhone}`, "_self")}
          >
            <Phone className="h-4 w-4" />
            Contact Us
          </Button>
        )
      )}

      <p className="mt-7 max-w-sm text-xs text-gray-400">
        You can still use the menu on the left to view your profile or log out.
      </p>
    </div>
  );
};

export default AccessBlockOverlay;
